import type { RouteRecordRaw } from "vue-router";
const onError = (err: any) => {
  console.error("Failed to load async component: ", err);
  throw new Error(err);
};

const Notification: RouteRecordRaw = {
  name: "通知平台",
  path: "/notification",
  component: () => import("@/components/Layout/index.vue").catch(onError),
  redirect: "/notification/message-account",
  meta: {
    key: "/notification"
  },
  children: [
    {
      name: "消息账号管理",
      path: "message-account",
      meta: {
        key: "/notification/message-account"
      },
      component: () =>
        import("@/views/Notification/MessageAccount/index.vue").catch(onError)
    },
    {
      name: "消息模板管理",
      path: "message-template",
      meta: {
        key: "/notification/message-template"
      },
      component: () =>
        import("@/views/Notification/MessageTemplate/index.vue").catch(onError)
    },
    {
      name: "消息日志查询",
      path: "message-log",
      meta: {
        key: "/notification/message-log"
      },
      component: () =>
        import("@/views/Notification/MessageLog/index.vue").catch(onError)
    }
  ]
};

export default Notification;
